export enum AppEnvironment {
  Development = 'development',
  Production = 'production',
}
